"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import AdvertiseForm from "./AdvertiseForm";
interface AdvertisePopupProps {
  children?: React.ReactNode;
}
export default function AdvertisePopup(t0) {
  const $ = _c(12);
  const {
    children
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const [mounted, setMounted] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setMounted(true);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsOpen(true);
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const openPopup = t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setIsOpen(false);
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const closePopup = t4;
  const t5 = children || "Advertise with us";
  let t6;
  if ($[4] !== t5) {
    t6 = <button onClick={openPopup} className="text-[14px] text-gray-400 hover:text-gray-600 hover:underline cursor-pointer border-none bg-transparent p-0 mt-1">{t5}</button>;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== isOpen || $[7] !== mounted) {
    t7 = mounted && isOpen && createPortal(<div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50" style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      width: "100vw",
      height: "100vh"
    }}><button className="absolute inset-0 bg-transparent" aria-label="Close advertise form" onClick={closePopup} /><div className="relative w-full max-w-md lg:max-w-[537px] max-h-[90vh] overflow-y-auto bg-white shadow-lg mx-4 rounded-lg" onClick={_temp}><AdvertiseForm onClose={closePopup} /></div></div>, document.body);
    $[6] = isOpen;
    $[7] = mounted;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t6 || $[10] !== t7) {
    t8 = <>{t6}{t7}</>;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
}
function _temp(e) {
  return e.stopPropagation();
}